//vendors
import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import flickity from 'flickity';
import 'flickity-fade';
import 'flickity-imagesloaded';

flickity.setJQuery($);
jQueryBridget('flickity', flickity, $);

window.$ = window.jQuery = $;
window.Flickity = flickity;